import { render, staticRenderFns } from "./BorderBox12.vue?vue&type=template&id=0b571815"
import script from "./BorderBox12.vue?vue&type=script&lang=js"
export * from "./BorderBox12.vue?vue&type=script&lang=js"
import style0 from "./BorderBox12.vue?vue&type=style&index=0&id=0b571815&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports